import Vue from 'vue';
import Vuex from 'vuex';
import multiLanguage from './modules/multi-language';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 打球手机站域名
    WAP_HOST: process.env.WAP_URL,
    // 百高微信分享图标链接
    BG_LOGO_URL: 'https://w.baigolf.com/templates/images/baigolf_logo.png',

    rooms: 1,     // 房间数
    adults: 1,    // 成人数
    children: 0,  // 儿童数
    ages: '',     // 儿童年龄

    roomTypeData: {}, // 房型数据
  },
  getters: {
    getRooms(state){
      let result = +state.rooms;
      const local = window.localStorage.getItem('rooms');

      if(local){
        result = +local;
      }

      return result;
    },

    getAdults(state){
      let result = +state.adults;
      const local = window.localStorage.getItem('adults');

      if(local){
        result = +local;
      }

      return result;
    },

    getChildren(state, getters, rootState){
      let result = +state.children;
      // const local = window.localStorage.getItem('children');
      const local = window.localStorage.getItem('child');

      if(local){
        result = +local;
      }

      return result;
    },

    getAges(state, getters, rootState){
      let result = state.ages;
      const local = window.localStorage.getItem('ages');

      if(local){
        result = local;
      }

      return result;
    },

    /** 获取房型方案数据 */
    getRoomPlanData(state, getters, rootState){
      return state.roomTypeData;
    },
  },

  mutations: {
    ROOMS(state, cur) {
      window.localStorage.setItem('rooms', cur);
      state.rooms = cur;
    },

    ADULTS(state, cur){
      window.localStorage.setItem('adults', cur);
      state.adults = cur;
    },

    CHILDREN(state, cur){
      window.localStorage.setItem('child', cur);
      state.children = cur;
    },

    AGES(state, cur){
      window.localStorage.setItem('ages', cur.join(','));
      state.ages = cur.join(',');
    },

    /** 保存当前选择的房型方案数据 */
    ROOM_TYPE_DATA(state, curData){
      state.roomTypeData = curData;
    },
  },
  actions: {
    setRooms({commit}, room){
      commit('ROOMS', room);
    },

    setAdults({commit}, adult){
      commit('ADULTS', adult);
    },

    setChildren({commit}, children){
      commit('CHILDREN', children);
    },

    setAges({commit}, ages){
      commit('AGES', ages)
    },

    /** 保存当前选择的房型方案数据 */
    setRoomTypeData({commit}, roomTypeData){
      commit('ROOM_TYPE_DATA', roomTypeData);
    },
  },

  modules: {
    multiLanguage,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js